import { useNavigate } from "react-router-dom";
import { usePerformanceSummary } from "../../hooks/usePerformanceSummary";
import ModelExplanationGrid from "./ModelExplanationGrid";
import UserHistoryDashboard from "./UserHistoryDashboard";


const WelcomeDashboard = () => {
  const navigate = useNavigate();
  const { data, loading, error } = usePerformanceSummary();

  const handleGetStarted = () => {
    navigate("/dashboard/data-entry");
  };


  return (
    <>
      {/* {data?.processed_files.length === 0 ? (
        <>
          <ModelExplanationGrid handleGetStarted={handleGetStarted} />
        </>
      ) : (
        <UserHistoryDashboard data={data} handleGetStarted={handleGetStarted} loading={loading} />
      )} */}
       <ModelExplanationGrid handleGetStarted={handleGetStarted} />
    </>
  );
};


export default WelcomeDashboard;